/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c79209527496ded28415bb6d06619cad>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const StatusVerifiedIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.226.95c-.696.54-.87 1.52-.4 2.266l.828 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var _default = exports.default = StatusVerifiedIcon;